import styled from 'styled-components';
import { NegativeBadge, PositiveBadge, WarningBadge } from 'ui/badge';
import { SecondaryButton } from 'ui/button';
import { WarningFill16 } from 'ui/icons';
import { ProvisionedEmptyState } from 'ui/illustrations';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { body1, body2, colors, fontSizes, heading4, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

export const IntegrationActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing.half};
`;

export const UpdateIntegrationButton = styled(SecondaryButton)`
  padding: ${spacing.half};
`;

export const StyledTableHeader = styled(TableHeader)`
  > div {
    padding: ${spacing.half} ${spacing.base};
  }
`;

export const StyledTableRows = styled(TableRows)`
  > div {
    background-color: ${colors.white};
    padding: ${spacing.double} ${spacing.base};
  }
  &:not(:last-child) {
    border-bottom: ${spacing.single} solid ${colors.grey15};
  }
`;

export const StyledTooltip = styled(Tooltip)`
  width: 100%;

  > button {
    grid-template-columns: auto;
  }
`;

export const BossRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const RowCell = styled.div`
  ${body2};
  display: table-cell;
  box-sizing: border-box;
  padding: ${spacing.threeQuarter} ${spacing.half};
  vertical-align: middle;
`;

export const StyledExpirationLabel = styled.div`
  font-size: ${fontSizes.s12};
  color: ${colors.textSecondary};
`;

export const StyledPositiveBadge = styled(PositiveBadge)<{ isBackgroundTransparent?: boolean }>`
  color: ${colors.green100};
  background-color: ${({ isBackgroundTransparent }) =>
    isBackgroundTransparent ? 'transparent' : colors.green10};
  ${({ isBackgroundTransparent }) => (isBackgroundTransparent ? 'padding: 0;' : '')}
  && path {
    fill: ${colors.green100} !important;
    stroke: none;
  }
`;

export const StyledWarningBadge = styled(WarningBadge)`
  color: ${colors.mustard50};
  padding: 0;
  background-color: transparent;
  > span {
    color: ${colors.mustard100};
  }
`;

export const StyledNegativeBadge = styled(NegativeBadge)`
  color: ${colors.negative100};
  padding: 0;
  background-color: transparent;
`;

export const StyledWarningIcon = styled(WarningFill16)`
  path {
    fill: ${colors.iconWarning} !important;
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing.half};
  padding: ${spacing.x4};
`;

export const GetStartedIcon = styled(ProvisionedEmptyState)`
  margin-bottom: ${spacing.half};
`;

export const PrimaryText = styled.div`
  ${heading4}
  color: ${colors.textPrimary};
`;

export const SecondaryText = styled.div`
  ${body1}
  color: ${colors.textSecondary};
`;
